<template>
  <b-modal :active.sync="isModalActive" has-modal-card :can-cancel="false">
    <div class="modal-card size-xl-modal">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Rule</h1>
      </header>
      <section class="modal-card-body overflow-scroll">
        <div class="columns">
          <div class="column">
            <b-field label="Name">
              <b-input
                v-model="ruleName"
                name="name"
                placeholder="Rule Name"
                required
              ></b-input>
            </b-field>
            <tree :tree-data="tree" :action="action"></tree>
          </div>
        </div>
        <div class="columns rule_action">
          <div class="rule_tag_dropdown">
            <b-field>
              <b-dropdown
                v-model="ruleTag"
                :data="ruleTags"
                multiple
                ref="dropdown"
                aria-role="list"
                :scrollable="true"
              >
                <template slot="trigger">
                  <button class="button dropdown-button" type="button">
                    <span v-if="ruleTag.length > 0"
                      >Selected ({{ ruleTag.length }})</span
                    ><span v-else>Select Stream</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>
                </template>
                <b-dropdown-item custom aria-role="listitem">
                  <label class="b-checkbox checkbox">
                    <input
                      type="checkbox"
                      v-model="allSelected"
                      @input="ruleTag = selectAll(ruleTags)"
                    />
                    <span class="check select-checkbox"></span>
                    <span class="control-label">
                      <span class="select-all-label">Select all</span>
                    </span>
                  </label>
                </b-dropdown-item>
                <b-dropdown-item
                  custom
                  aria-role="listitem"
                  v-for="(option, index) in ruleTags"
                  :key="index"
                >
                  <label class="b-checkbox checkbox">
                    <input
                      type="checkbox"
                      v-model="ruleTag"
                      :value="option.name"
                      @input="customItem(ruleTag, ruleTags, option.name)"
                    />
                    <span class="check"></span>
                    <span class="control-label">
                      <span>{{ option.name }}</span>
                    </span>
                  </label>
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
          </div>
          <div class="rule_action_check column columns">
            <div class="rule_action_func_checkBox column is-3">
              <b-checkbox
                v-model="showActionFields"
                name="actionCheckBox"
                value="false"
                style="padding-top: 10px;"
              >
                Action function
              </b-checkbox>
            </div>
            <div class="rule_action_function column is-3">
              <b-field v-if="showActionFields">
                <b-select placeholder="Select" v-model="actionFunction">
                  <option value=""></option>
                  <option value="pack_composite_action"
                    >pack_composite_action</option
                  >
                  <option value="tabular_pack_composite_action"
                    >tabular_pack_composite_action</option
                  >
                </b-select>
              </b-field>
            </div>
            <div class="rule_action_value column is-2">
              <b-field v-if="showActionFields">
                <b-input
                  v-model="actionValue"
                  placeholder="Action Percentage"
                  type="number"
                  min="0"
                  max="100"
                >
                </b-input>
              </b-field>
            </div>
            <div class="rule_action_reporting_category column is-4">
              <b-field v-if="showActionFields">
                <multiselect
                  v-model="reportingCategory"
                  :options="reportingCategories || []"
                  label="category"
                  track-by="id"
                  placeholder="Reporting Categories"
                  :searchable="true"
                  :limit="10"
                ></multiselect>
              </b-field>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!viewOnly">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
        >
          Save Rules
        </b-button>
        <b-button slot="right" class="is-normal" @click="cancel">
          Cancel
        </b-button>
        <span v-on:click="viewSyntex"><a href="#">See rule syntax</a></span>
        <span
          v-if="form.report_definition && form.report_definition.length > 0"
          v-on:click="checkReportDef"
          slot="right"
          class="check_deport_def_link"
          ><a href="#">Check Report Definitions</a></span
        >
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import Tree from "@/components/RulesManager/Tree.vue";
import Multiselect from "vue-multiselect";
import ReportingCategoryService from "@/services/ReportingCategoryService";
// @group Dashboard
export default {
  name: "AddScope",
  components: { Tree, Multiselect },
  mixins: [UtilityMixin, scopeMixin],
  props: {
    action: {
      type: String,
      default: "Add"
    },
    viewOnly: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object
    },
    ruleTags: [],
    form: {
      type: Object,
      default: () => {
        return {
          id: "",
          country: "",
          scheme: "",
          stream: "",
          conjunction: "where"
        };
      }
    }
  },

  data() {
    return {
      allSelected: false,
      reportingCategories: [],
      reportingCategory: null,
      reportingCategoryService: new ReportingCategoryService(),
      noValue: true,
      maxLabel: 0,
      showActionFields: false,
      actionValue: null,
      actionFunction: null,
      isModalActive: false,
      loading: "",
      ruleName: "",
      ruleTag: [],
      tree: {
        label: "Parent",
        form: {},
        children: [
          {
            label: 1,
            form: {
              id: "",
              value: "",
              operator: "",
              property: "",
              condition: "where"
            },
            children: []
          }
        ]
      }
    };
  },
  methods: {
    filterReportingTypes() {
      this.reportingCategoryService.getAllReportingTypes().subscribe(
        response => {
          this.reportingCategories = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    customItem(arr, status, value) {
      this.allSelected = false;
      let col = arr;
      col.includes(value)
        ? (col = col.filter(item => item !== value))
        : col.push(value);
      if (col.length === status.length) {
        this.allSelected = true;
      }
      if (col.length > 0) {
        //this.enableSearch();
      }
      return col;
    },
    selectAll(values) {
      let arr = [];
      if (this.allSelected === true) {
        arr = [];
        this.allSelected = false;
      } else {
        this.allSelected = true;
        values.forEach(element => {
          arr.push(element.name);
        });
      }
      return arr;
    },
    cancel() {
      this.$store.state.treeKeyId = 1;
      this.ruleName = null;
      this.showActionFields = false;
      this.actionFunction = null;
      this.actionValue = null;
      this.reportingCategory = null;
      this.ruleTag = [];
      this.tree = {
        label: "Parent",
        form: {},
        children: [
          {
            label: 1,
            form: {
              id: "",
              value: "",
              operator: "",
              property: "",
              condition: "where"
            },
            children: []
          }
        ]
      };
      this.$emit("cancel");
    },
    remove(nodeId) {
      this.filterId([this.$store.state.treeRule], nodeId);
    },
    filterId(data) {
      this.noValue = true;
      data.forEach(o => {
        if (o.form && o.form.value == "") {
          this.noValue = false;
        } else if (o.children) {
          this.filterId(o.children);
        }
      });
    },
    submit() {
      if (this.ruleName) {
        const formData = {};
        formData["rule_json"] = this.tree;
        formData["name"] = this.ruleName;
        formData["action_value"] = this.actionValue;
        formData["reporting_category"] = this.reportingCategory;
        formData["action_function"] = this.actionFunction;
        const selectedIds = this.ruleTags.filter(item =>
          this.ruleTag.includes(item.name)
        );
        formData["tags"] = selectedIds.map(a => a.id);
        this.filterId([this.tree]);
        if (this.noValue) {
          this.$emit("confirm", formData);
        } else {
          this.$buefy.toast.open({
            duration: 2000,
            message: `Choose at least one condition.`,
            type: "is-danger"
          });
        }
      } else {
        this.$buefy.toast.open({
          duration: 2000,
          message: `Please fill the "Rule Name" field`,
          type: "is-danger"
        });
      }
    },
    viewSyntex() {
      this.$emit("viewSyntex");
    },
    checkReportDef() {
      this.$emit("checkReportDef");
    },
    findMaxLabel(data) {
      data.forEach((o, i) => {
        if (o.label && o.label > this.maxLabel) {
          this.maxLabel = o.label;
        } else if (o.children) {
          this.findMaxLabel(o.children);
        }
      });
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
      if (newValue) {
        this.filterReportingTypes();
      }
    },
    rules(newValue) {
      const tagSelected = this.ruleTags.filter(item =>
        newValue.tags.includes(item.id)
      );
      this.tree = newValue.rule_json;
      this.findMaxLabel([this.tree]);
      this.$store.state.treeKeyId = this.maxLabel;
      this.$store.state.treeRule = this.tree;
      this.ruleName = newValue.name;
      this.ruleTag = tagSelected.map(a => a.name);
      if (newValue.action_function && newValue.action_value) {
        this.showActionFields = true;
        this.actionFunction = newValue.action_function;
        this.actionValue = newValue.action_value;
        this.reportingCategory =
          this.reportingCategories.find(
            cat =>
              cat.id ===
              (newValue.reporting_category?.id || newValue.reporting_category)
          ) || null;
      }
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
